import _ from 'lodash';
import { getAxiosClient } from '../../api';
import { notify } from '~src/notifications';
import { isLoggedUserGlobalEditor } from '~src/user';
import { FEATURES, isFeatureEnabled } from '../../features';

/**
 * Funzione che scarica i projects (tipi).
 * Se i tipo sono gia stati scaricati e memorizzati nella
 * cache (window.editorLoader), la chiamata HTTP viene saltata
 * a meno che venga specificato il parametro "forceFetch = true"
 */
export const fetchEditorProjectTypes = async (forceFetch = false) => {
  const httpClient = await getAxiosClient();

  const hasCache = _.has(window.editorLoader, 'projects.items');

  if (!forceFetch && hasCache) {
    return { projects: window.editorLoader.projects };
  }

  /**
   * Get default types
   */
  const promiseDefaultTypes = httpClient.get(
    `${process.env.PARSE_API_URL}/editor_project_types_default`,
    {
      params: {
        filterEqual_isGlobal: true,
        sort_ascending: 'order',
        include: 'default_formats',
      },
    }
  );

  const allowNew = await isFeatureEnabled(FEATURES.CREATE_PROJECT_TYPES);

  const isGlobalEditor = await isLoggedUserGlobalEditor();

  /**
   * Get custom types
   */
  const promiseCustomTypes = httpClient.get(
    `${process.env.PARSE_API_URL}/editor_project_types`
  );

  try {
    const responses = await Promise.all([
      promiseDefaultTypes,
      promiseCustomTypes,
    ]);

    let items = [];

    responses.forEach((response) => {
      const respItems = response.data.data.reduce((acc, item) => {
        acc.push(item);

        return acc;
      }, []);

      items = [...items, ...respItems];
    });

    return {
      projects: {
        allowNew: isGlobalEditor || allowNew || false,
        items,
      },
    };
  } catch (errors) {
    console.error('[API:fetchEditorProjectTypes] errors ->', errors);
    notify({
      type: 'error',
      title: 'Si è verificato un problema',
      text: 'Non è stato possibile caricare i dati. Si prega di riprovare.',
    });
    return errors;
  }
};
